import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8583eb9c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8583eb9c')) {
      api.createRecord('8583eb9c', component.options)
    } else {
      api.reload('8583eb9c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8583eb9c", function () {
      api.rerender('8583eb9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Administration/Logs/index.vue"
export default component.exports